var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markets-status"},[_c('TextTitle',{attrs:{"size":"s"}},[_vm._v(_vm._s(_vm.$t(`market.markets`)))]),_vm._l((_vm.marketStatus),function(status){return _c('Status',{key:status.countryCode,attrs:{"text":_vm.$t(`countries_code.${status.countryCode}`),"valid":status.isPresent,"border":false,"size":"m"}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }